import { ReactNode } from "react";

export function BannerContainer({ children }: { children: ReactNode }) {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        paddingTop: "var(--ion-safe-area-top, 0px)",
        width: "100%",
        position: "sticky",
        top: 0,
        zIndex: 6,
      }}
    >
      {children}
    </div>
  );
}
